<h5>Documentos seleccionados</h5>
<div class="table-container">
    <mat-table [dataSource]="documentsDataSource">
        <ng-container matColumnDef="estados">
            <mat-header-cell *matHeaderCellDef>N&uacute;mero</mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element">
                <div>{{ element.anio + "-" + element.numero }}</div>
                <app-estados-documento [documento]="element"></app-estados-documento>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="asunto">
            <mat-header-cell *matHeaderCellDef> Asunto </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.asunto}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fecha">
            <mat-header-cell *matHeaderCellDef> Fecha </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{formatDate(element.fecha)}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numeroDocumento">
            <mat-header-cell *matHeaderCellDef>N&uacute;mero documento</mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element">
                <span>{{ element.numeroDocumento }}</span>
                <span>{{ element.anio + "-" + element.numero }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="para">
            <mat-header-cell *matHeaderCellDef> Para </mat-header-cell>
            <mat-cell *matCellDef="let element">
                @for (item of element.para; track $index) {
                <p>{{item.nombres}}</p>
                }
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
</div>